module.exports = __webpack_public_path__ + "static/media/noRecordFound.a83076ea.png";